import React from "react";
import { Column } from "@ant-design/plots";

const ChartTraditional = ({ data, type }) => {
  const mappingColorColumn = (name) => {
    switch (name) {
      case "Cấu trúc":
        return "#0095FF";
      case "Thực hành chăn nuôi":
        return "#14C9C9";
      case "Quản lý":
        return "#50D266";
      case "Vận chuyển":
        return "#A974E3";
      case "Vật dụng và vật tư":
        return "#C9CDD4";
      case "Động vật":
        return "#F7BA1E";
      case "Thức ăn, nước uống":
        return "#F98D86";
      case "Con người":
        return "#FCE995";

      default:
        break;
    }
  };

  const mapDataColumnTestTraditional = (listData) => {
    const mappedData = [];

    listData?.forEach((data) => {
      data.info.forEach((item) => {
        const monthName = `Tháng ${item.month}`;
        mappedData.push({
          month: monthName,
          value:
            type === "total"
              ? Number(item.noFarm)
              : Number(item.avgMark),
          name: data.name,
        });
      });
    });

    return mappedData;
  };

  const configTestTraditional = {
    data: mapDataColumnTestTraditional(data),
    height: 550,
    xField: "month",
    yField: "value",
    seriesField: "name",
    marginRatio: 0.5,
    isGroup: true,
    columnStyle: {
      radius: [20, 20, 0, 0],
    },
    legend: {
      position: "bottom",
    },
    yAxis: [
      {
        min: 0,
        tickInterval: 10,
      },
      {
        min: 0,
        tickInterval: 10,
      },
    ],
    spacing: 4,
    tooltip: {
      shared: false,
      showMarkers: true,

      customContent: (title, items) => {
        return `<div style="padding: 10px;">
                  <h4>${title}</h4>
                  ${items
                    .map(
                      (item) =>
                        `<div>
                    <p style="font-size: 14px; font-weight: bold;">${
                      item.name
                    }</p>
                    <div>
                      <p style="font-size: 12px; margin-bottom:5px">${
                        type === "total" ? "Số lượng trại" : "Điểm trung bình"
                      }</p>
                     <div style="display:flex; align-items:center">
                    <div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color:${mappingColorColumn(
                      item.name
                    )};"></div>
                     <p style="font-size: 20px; margin:0px">${item.value}</p>
                     </div>
                    </div>
                  </div>`
                    )
                    .join("")}
                </div>`;
      },
    },
    colorField: "name", // or seriesField in some cases
    color: ({ name }) => {
      return mappingColorColumn(name);
    },
  };

  return <Column {...configTestTraditional} />;
};
export default ChartTraditional;
